import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import flex from '../../css/module/flex.css';
import elements from '../../css/module/elements.css';
import style from '../../css/module/tables.css';
import AjaxSpinner from '../AjaxSpinner';

class ConfigurePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingIsTakingAWhile: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.loading) {
        this.setState({
          loadingIsTakingAWhile: true,
        });
      }
    }, 20 * 1000);
  }

  render() {
    const {
      disabled,
      controlSection,
      title,
      saveButtonText,
      isModal,
      loading,
      loadError,
      showLoadingMessage,
      showConfigureNote,
      onForceRefresh,
    } = this.props;

    const forceRefresh = () => {
      onForceRefresh();
      this.setState({
        loadingIsTakingAWhile: false, // hide button
      });
    };

    if (loading) {
      return (
        <div
          className={`${style.mainContainer} w-100 h-100 ${flex.flex} ${flex.alignItemsCenter} ${flex.justifyContentCenter}`}
        >
          <AjaxSpinner />
          {!showLoadingMessage ? null : (
            <div>
              <b>Preparing the list of tables for your database.</b>
              <br />
              <small>
                Note: this can take a couple of minutes if you have a lot of
                tables.
              </small>
              {!this.state.loadingIsTakingAWhile ? null : (
                <div>
                  <br />
                  <small>Is loading tables taking longer than expected?</small>
                  &nbsp;
                  <button className="btn btn-info" onClick={forceRefresh}>
                    Try again
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      );
    }

    if (!loading && loadError) {
      return (
        <div
          className={` w-100 h-100 ${flex.flex} ${flex.column} ${flex.alignItemsCenter} ${flex.justifyContentCenter}`}
        >
          <h3>Oh no! Something went wrong.</h3>
          <br />
          <h3>
            Please refresh your page, or{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                Intercom('show');
              }}
            >
              chat with us
            </a>
            .
          </h3>
        </div>
      );
    }

    const content = !showConfigureNote ? (
      this.props.children
    ) : (
      <div style={{ padding: '50px' }}>
        <div className={elements.note}>
          <h5>You need to activate this feature.</h5>
          <p>
            To enable <b>Configure Joins</b>, please first choose your visible
            tables.
          </p>
          <Button
            className="margin-top-20 margin-bottom-20"
            onClick={this.props.onOpenConfigureTablesModal}
          >
            Choose visible tables
          </Button>
          <p>Once done, simply head back here for some join goodness!</p>
        </div>
      </div>
    );

    return (
      <div
        className={`${style.modalContainer} ${flex.flex} ${flex.column} h-100 w-100`}
      >
        <div
          className={`${style.modalHeader} ${flex.flex} ${flex.column} ${flex.shrink0}`}
        >
          <h1
            style={
              this.props.justifyCenter
                ? { textAlign: 'center', marginTop: '30px', fontSize: '1.5em' }
                : {}
            }
          >
            {title}
          </h1>
          {controlSection || null}
        </div>
        <div className={`${style.body} ${flex.flexGrow} overflow-auto w-100`}>
          <div className={style.tablesContainer}>{content}</div>
        </div>
        {showConfigureNote ? null : (
          <div
            className={style.modalFooter}
            style={this.props.justifyCenter ? { justifyContent: 'center' } : {}}
          >
            <div className={flex.flex}>
              {this.props.cancelButtonShown && (
                <Button
                  variant="secondary"
                  onClick={this.props.cancel}
                  style={{ marginRight: '10px' }}
                >
                  {this.props.cancelText || 'Cancel'}
                </Button>
              )}
              <Button
                onClick={this.props.onSave}
                disabled={disabled}
                id={isModal ? '' : 'save-finish-database-configured'}
              >
                {saveButtonText || 'Save'}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ConfigurePage;
